import {hot} from "react-hot-loader/root";
import React, {Component} from "react";
import { withRouter} from "react-router-dom";
import _ from "lodash";
import {Spin} from "antd";

import Layout from "./../containers/LayoutContainer";
import connect from "react-redux/es/connect/connect";
import {
    authGetCurrentUserInfos,
    setAuthToken,
    authGetUpsellTokenFromMicrosoft
} from "./../redux/actions/authActions";
import {setCurrentClient} from "redux/actions/authActions";
import {FormattedMessage} from "react-intl";
import Login from "./login";


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogout: localStorage.access_token ? false : true,
            isUserInfoLoading: true
        };
    }

    componentDidMount() {
        // if (localStorage.access_token)
        const token = localStorage.getItem("access_token");

        if (token) this.props.setAuthToken(token);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.token !== this.props.token) {
            this.props.token.trim() !== "" ? this.props.authGetCurrentUserInfos() : this.setState({isLogout: true});
        } else if (prevProps.userInfos !== this.props.userInfos) {
            if (!_.isEmpty(this.props.userInfos) && !_.isEmpty(this.props.userInfos.clients)) {
                localStorage.currentClient
                    ? this.props.setCurrentClient(JSON.parse(localStorage.getItem("currentClient")))
                    : this.props.setCurrentClient(this.props.userInfos.clients[0]);
                this.setState({
                    isUserInfoLoading: false,
                    isLogout: false
                });
            }
        }
    }

    // Sign up
    handleAuthClickMicrosoft = (data) => {
        this.props.authGetUpsellTokenFromMicrosoft(data.idToken);
    };

    // Log out
    revokeAccess = () => {
        this.setState({
            isLogout: true
        });
    };

    render() {
        const localHost = window.location.hostname;
        
        return (
          <React.Fragment>
            {this.state.isLogout && (
              <Login
                handleAuthClickMicrosoft={this.handleAuthClickMicrosoft}
              />
            )}

            {this.state.isUserInfoLoading && (
              <div
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                  marginBottom: "20px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%"
                  }}
                >
                  <Spin size="large" />
                  <p
                    style={{
                      margin: "0 0 0 20px",
                      padding: 0,
                      fontWeight: "600",
                      fontSize: "24px"
                    }}
                  >
                    {
                      <FormattedMessage id={"Chargement"} defaultMessage={"Chargement"}>
                        {txt => <React.Fragment>{txt}</React.Fragment>}
                      </FormattedMessage>
                    }
                    ...
                  </p>
                </div>
              </div>
            )}
            {!this.state.isUserInfoLoading && (
              <Layout
                {...this.props}
                loggout={function() {
                  this.revokeAccess();
                }}
              />
            )}
          </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userInfos: state.userInfos,
        token: state.auth.token,
        logged: state.auth.logged
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        authGetUpsellTokenFromMicrosoft: (token, username) => {
            dispatch(authGetUpsellTokenFromMicrosoft(token, username));
        },
        authGetCurrentUserInfos: () => dispatch(authGetCurrentUserInfos()),
        setAuthToken: token => dispatch(setAuthToken(token)),
        setCurrentClient: clientInfos => dispatch(setCurrentClient(clientInfos))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(hot(App)));



// WEBPACK FOOTER //
// src/components/App.js